/**
 * Applies create-path defaults for feature item entities.
 */
export function applyFeatureItemCreateDefaults<
  T extends {
    isVisible?: boolean | null;
  },
>(item: T): T {
  item.isVisible = item.isVisible ?? true;

  return item;
}
